import axios from "axios";
import { createHeadersAdmin } from "../utils/Utils";
import { BASE_URL } from "../assets/constants/constants";


//! dashboard
//  Dashboard
export const dashboardAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}dashboard`, data,headers);
};
// Sidebar
export const sideBarAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}get-menu-data`, data,headers);
};
// Feed Back List API
export const feedBackListAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}get-feedback-list`, data,headers);
};

// CK_EDITOR verify API
export const verifyAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}verify`, data,headers);
};

//!Grievance List
export const getGrievanceListAPI = async(data)=>{
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}list-grievances`,data,headers)
} 
//!Grievance Response
export const replyGrievanceAPI = async(data)=>{
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}reply-grievance`,data,headers)
} 


